import commonService from './services/common.service';
import uiService from './services/ui.service';
import dialogService from './services/dialog.service';
import toasterService from './services/toaster.service';
import informationService from './services/information.service';
import uploaderService from './services/uploader.service';
import checkUsersService from './services/checkUsers.service';
import checkOrgUsersService from './services/checkOrgUsers.service';
import checkOrganizationService from './services/checkOrganization.service';
import checkChangeProjectsService from './services/checkChangeProjects.service';
import chatService from './services/chat.service';
import projectService from './services/project.service';
import diffProjectsService from './services/diffProjects.service';
import organizationService from './services/organization.service';
import timeService from './services/time.service';
import userService from './services/user.service';
import auditService from './services/audit.service';
import authService from './services/auth.service';
import permissionService from './services/permission.service';
import workflowService from './services/workflow.service';
import receiptService from './services/receipt.service';
import turnService from './services/turn.service';
import helpService from './services/help.service';
import updatePasswordService from './services/updatePassword.service';
import connectAdminService from './services/connectAdmin.service';
import editProjectAttributeService from './services/editProjectAttribute.service';
import aboutService from './services/about.service';
import updateAuthLicenseService from './services/updateAuthLicense.service';
import relativeTaskService from './services/relativeTask.service';
import ssoService from './services/sso.service';
import scheduleTimesService from './services/scheduleTimes.services';



export default {
    'commonService': commonService,
    'uiService': uiService,
    'dialogService': dialogService,
    'toasterService': toasterService,
    'informationService': informationService,
    'uploaderService': uploaderService,
    'checkUsersService': checkUsersService,
    'checkOrgUsersService': checkOrgUsersService,
    'checkOrganizationService': checkOrganizationService,
    'checkChangeProjectsService': checkChangeProjectsService,
    'chatService': chatService,
    'projectService': projectService,
    'diffProjectsService': diffProjectsService,
    'organizationService': organizationService,
    'timeService': timeService,
    'userService': userService,
    'auditService': auditService,
    'authService': authService,
    'permissionService': permissionService,
    'workflowService': workflowService,
    'receiptService': receiptService,
    'turnService': turnService,
    'helpService': helpService,
    'updatePasswordService': updatePasswordService,
    'connectAdminService': connectAdminService,
    'editProjectAttributeService': editProjectAttributeService,
    'aboutService': aboutService,
    'updateAuthLicenseService': updateAuthLicenseService,
    'relativeTaskService': relativeTaskService,
    'ssoService': ssoService,
    'scheduleTimesService': scheduleTimesService
};